import { formatCurrencyAndAmount } from '../../../utils/stringUtils'

export const RefundableAmountCard = (props: { currency: string; refundableAmount: number }) => (
    <div
        className={`flex-col flex-1 rounded-lg p-4 shadow-lg ${
            props.refundableAmount > 0 ? 'bg-purple-lightest' : 'bg-grey-lightest'
        }`}
    >
        <h3 className="text-lg">Refundable amount</h3>
        <p className="font-moret">{formatCurrencyAndAmount(props.currency, props.refundableAmount)}</p>
    </div>
)
